<template>
<div class="wrapper" :class="{'broad':tabB}">
  <div class="container" :class="{'newStyle2':newStyle}">
    <div v-show="tabA">
      <div class="cont-head" :class="{'newStyle':!newStyle}">
        <span>{{$t('sign up')}}</span>
      </div>
      <div  class="user-type">
        <div class="user-left" :class="{ 'Select2':isB, 'choose-left': isB }" @click.prevent="check2()">
          <input type="radio" :class="[ isB ?'hide1':'']">
          <label>{{$t('Patient')}}</label>
        </div>
        <div class="user-right" :class="{ 'Select2':isC, 'choose-right': isC }" @click.prevent="check2()">
          <input type="radio" :class="[ isC ?'hide1':'']">
          <label>{{$t('Caregiver')}}</label>
        </div>
      </div>
      <div  class="user-type" v-show="newStyle">
        <div class="user-left" :class="{ 'Select2':isD, 'choose-left': isD }" @click.prevent="check3">
          <input type="radio" :class="[ isD ?'hide1':'']">
          <label>{{$t('Email')}}</label>
        </div>
        <div class="user-right" :class="{ 'Select2':isE, 'choose-right': isE }"@click.prevent="check3">
          <input type="radio" :class="[ isE ?'hide1':'']"> <label>{{$t('Mobile')}}</label>
        </div>
      </div>
      <hr :class="{'broad':tabB}">
      <div id = 'inputGroup'>
        <div class="icon-bor">
          <!--  德国包括 DD 和 DE 两个  -->
          <select id="chooseCountry" @change="select" >
            <option value="GB">United Kingdom (mmol/L)</option>  <!-- 英国 -->
            <option value="AU">Australia (mmol/L)</option>  <!-- 澳大利亚 -->
            <option value="CN">中国 (mmol/L)</option>  <!-- 中国 -->
            <option value="HKF">香港(中国) (mmol/L)</option>  <!-- 中国香港 -->
            <option value="TH">Thailand (mg/dL)</option>  <!-- 泰国 -->
            <option value="ID">Indonesia (mg/dL)</option>  <!-- 印度尼西亚 -->
            <option value="MY">Malaysia (mmol/L)</option>    <!-- 马来西亚 -->
            <option value="IN">India (mg/dL)</option>   <!-- 印度 -->
            <option value="FR">France (mg/dL)</option>  <!-- 法国 -->
            <option value="DE">Deutschland (mg/dL)</option>  <!-- 德国 -->
            <option value="DD">Deutschland (mmol/L)</option>  <!-- 德国 -->
            <option value="HU">Magyarország (mmol/L)</option>  <!-- 匈牙利 -->
            <option value="IT">Italia (mg/dL)</option>    <!-- 意大利 -->
            <option value="NL">Nederland (mmol/L)</option>  <!-- 西班牙 -->
            <option value="Nor">Norge (mmol/L)</option>   <!-- 挪威 -->
            <option value="PT">Portugal (mg/dL)</option>   <!-- 葡萄牙 -->
            <option value="ES">España (mg/dL)</option>    <!-- 西班牙 -->
            <option value="SE">Sverige (mmol/L)</option>   <!-- 瑞典 -->
            <option value="TR">Turkey (mg/dL)</option>    <!-- 土耳其 -->
            <!--<option value="AE">United Arab Emirates (mg/dL)</option> -->    <!-- 阿联酋 -->
            <option value="Ro">Romania (mg/dL)</option>   <!-- 罗马尼亚 -->
            <option value="CZ">Czech republika (mmol/L)</option>  <!-- 捷克 -->
            <option value="SK">Slovenska republika (mmol/L)</option>   <!-- 斯洛伐克 -->
            <option value="LT">Lithuania (mmol/L)</option>   <!-- 立陶宛 -->
            <option value="PL">Polska (mg/dL)</option>    <!-- 波兰 -->
            <option value="DK">Danmark (mmol/L)</option>   <!-- 丹麦 -->
            <option value="FI">Suomi (mmol/L)</option>    <!-- 芬兰 -->
            <option value="CH">Switzerland (mmol/L)</option>  <!-- 瑞士 -->
            <option value="SA">Saudi  (mg/dL)</option>    <!-- 沙特 -->
            <option value="AE">United Arab (mmol/L)</option>  <!-- 阿联酋 -->
            <option value="QA">Qatar  (mmol/L)</option>   <!-- 卡塔尔 -->
            <option value="QW">Kuwait (mmol/L)</option>   <!-- 科威特 -->
            <!-- 2020.3.16 新增 -->
            <option value="RH">Croatia (mmol/L)</option>   <!-- 克罗地亚 -->
            <option value="AT">Austria (mg/dL)</option>   <!-- 奥地利 -->
            <option value="SI">Slovenia (mmol/L)</option>   <!-- 斯洛文尼亚 -->
            <option value="EE">Estonia (mmol/L)</option>   <!-- 爱沙尼亚 -->
            <option value="LV">Latvia (mmol/L)</option>   <!-- 拉脱维亚 -->
            <option value="BA">Bosnia and Herzegovina (mmol/L)</option>   <!-- 波黑  -->
            <option value="BG">Bulgaria (mmol/L)</option>   <!-- 保加利亚 -->
            <option value="CL">Chile (mmol/L)</option>   <!-- 智利 -->
            <option value="BE">Belgium (mg/L)</option>   <!-- 比利时 -->
          </select>
        </div>

        <div class="icon-bor icon-spe4" v-show="isD" :class="{ 'in':isF,'vuerify-invalid':isO}">
            <el-tooltip  :disabled= disA  placement="top" effect="light" offset="-30">
              <div slot="content"  class="tooltip">
                <span>{{$t('errtip1-1')}}</span><br><span>{{$t('errtip1-2')}}</span>
              </div>
            <input  @keyup.down="down(1)" type="text" :placeholder=Ema  v-model="email" @focus="check54(0)" @blur="check54(1)">
            </el-tooltip>
           <div class="time" :class="{'in2':(isF || isO),'zh1':newStyle}">
             <button @click="sendSeccode" :disabled="canClick"><label><span v-show="showTime" class="showTime">{{time}}</span>{{send}}</label></button>
           </div>
        </div>

        <div class="icon-spe1" v-show="isE" :class="{ 'in':isG,'vuerify-invalid':isP}">
          <el-tooltip :disabled= disB  placement="top" effect="light" >
            <div slot="content"  class="tooltip">
              <span>{{$t('errtip2')}}</span>
            </div>
            <input  @keyup.down="down(1)" type="text" :placeholder=Mob v-model="mobile" @focus="check55(0)" @blur="check55(1)" >
          </el-tooltip>
          <div class="time" :class="{'in2':(isG || isP),'zh1':newStyle}">
            <button @click="sendSeccode" :disabled="canClick"><label><span v-show="showTime" class="showTime">{{time}}</span>{{send}}</label></button>
          </div>
        </div>

        <div class="icon-spe2" :class="{ 'in':isH ,'vuerify-invalid':isQ}">
          <el-tooltip :disabled= disC  placement="top" effect="light">
            <div class="tooltip"  slot="content">
              <span>{{$t('errtip3')}}</span>
            </div>
            <input  @keyup.down="down(2)"  @keyup.up="up(2)" type="text"  autocomplete="new-password" :placeholder=Veri v-model="vcode" @focus="check56(0)" @blur="check56(1)"  >
          </el-tooltip>
        </div>

        <div class="icon-bor" :class="{ 'in':isJ ,'vuerify-invalid':isS}">
          <el-tooltip :disabled= disE  placement="top" effect="light">
            <div class="tooltip"  slot="content">
              <span>{{$t('errtip5')}}</span>
            </div>
            <input  @keyup.down="down(4)" @keyup.up="up(4)" type="text" autocomplete="new-password" :placeholder=fullname  v-model="realname" @focus="check58(0)" @blur="check58(1)" >
          </el-tooltip>
        </div>

        <div class="icon-bor" :class="{ 'in':isK ,'vuerify-invalid':isT}">
          <el-tooltip :disabled= disF  placement="bottom" effect="light">
            <div class="tooltip"  slot="content">
              <p class="longP" :class="{'correct1':ps1}">{{$t('errp1')}}<br>{{$t('errp2')}}</p>
              <p :class="{'correct':ps2}">{{$t('errp3')}}</p>
              <p :class="{'correct':ps3}">{{$t('errp4')}}</p>
              <p :class="{'correct':ps4}">{{$t('errp5')}}</p>
              <p :class="{'correct':ps5}">{{$t('errp6')}}</p>
              <p :class="{'correct':ps6}">{{$t('errp7')}}</p>
            </div>
            <input  @keyup.up="up(5)" class="longps" type="password" autocomplete="new-password" :placeholder=Enterpas v-model="password" @focus="check59(0)" @blur="check59(1)">
          </el-tooltip>
        </div>
      </div>


      <div  class="operate"  :class="[ isA ?'xSelect':'xnoSelect']">

        <!--
        <input type="checkbox"  @click="check1()">
        <label>{{$t('agree')}}<span><a href="http://www.medtrum.com/privacy_policy.html">{{$t('privacy')}}</a></span>
         {{$t('and')}}<span><a href="http://www.medtrum.com/terms_of_use.html">{{$t('use')}}</a></span></label>-->
      </div>

      <div  @click="register" class="next_btn">
           <button class="register" :class="{'click':true,'newStyle1':!newStyle}" :disabled="isNext">{{$t('Next')}}</button>
      </div>
    </div>

    <div v-show="tabB">
      <div class="policy-wrap">
        <div v-show="true" class="text_wrap">
          <p v-html="$t('t1222_We_will_only_process')">
<!--            We will only process your Healthcare data through Medtrum App/website with your consent.-->
          </p><br/>

          <div v-show="isB">
            <p v-if="isEU" v-html="$t('t1221_register_eu')">
<!--              If you choose to register your Medtrum account and access our App using the account,-->
<!--              the healthcare data recorded on the App will be uploaded to our server in Europe and-->
<!--              be held for 2 years. You have the right not to upload any device data to the App,-->
<!--              in which case the data will not be accessible to others. If you choose not to register-->
<!--              in Medtrum App/website, the only record of your Healthcare data is on the device itself.-->
            </p>
            <p v-else v-html="$t('t1221_register_cn')">
            </p>
            <br/>
            <p v-html="$t('t1222_If_you_are_under_years')">
<!--              If you are under 16 years of age, you will need the consent of your parent or legal guardian to register in this App.-->
            </p>
            <br/>
          </div>




          <div class="check" :class="[ isA ?'Select':'noSelect']">
            <input type="checkbox"  @click="check1()">
            <span v-html="$t('t1222_I_Agree_to').replace('$1', '<a href=&quot;'+termsOfUseURL+'&quot; target=&quot;_blank&quot;>'+$t('t1222_Terms_of_Use')+'</a>')">
<!--              I Agree to <a :href="termsOfUseURL" target="_blank">the Terms of Use of Medtrum</a>-->
            </span>
          </div>

          <div class="check" :class="[ isA2 ?'Select':'noSelect']">
            <input type="checkbox"  @click="check1_2()">
            <span v-html="$t('t1222_I_Agree_to').replace('$1', '<a href=&quot;'+privacyURL+'&quot; target=&quot;_blank&quot;>'+$t('t1222_Privacy_Policy')+'</a>')">
<!--              I Agree to <a :href="privacyURL" target="_blank">the Privacy Policy of Medtrum</a>-->
            </span>
          </div>
          <br/>
        </div>

<!--        <div v-show="false">-->
<!--          <p>We will only process your Healthcare data through Medtrum App/website with your consent.</p> <br/>-->

<!--          <div v-show="isB">-->
<!--          <p>You have the right not to upload any device data to the App, in which case the data will not-->
<!--            be accessible to others. If you choose not to register in Medtrum App/website, the only record-->
<!--            of your Healthcare data is on the device itself.</p><br/>-->
<!--            <p>If you are under 16 years of age, you will need the consent of your parent or legal guardian to register in this App.</p><br/>-->
<!--          </div>-->




<!--          <div class="check" :class="[ isA ?'Select':'noSelect']">-->
<!--            <input type="checkbox"  @click="check1()">-->
<!--            <span>I Agree to <a href="http://www.medtrum.co.uk/terms_of_use.html" target="_blank">the Terms of Use of Medtrum</a></span>-->
<!--          </div>-->

<!--          <div class="check" :class="[ isA2 ?'Select':'noSelect']">-->
<!--            <input type="checkbox"  @click="check1_2()">-->
<!--            <span>I Agree to <a href="http://www.medtrum.com/privacy_policy.html" target="_blank">the Privacy Policy of Medtrum</a></span>-->
<!--          </div>-->
<!--          <br/><br/><br/><br/>-->
<!--        </div>-->


        <div >
          <button class="create-account" @click="register" :class="{'click':isAgree,'newStyle1':!newStyle}" :disabled="!isAgree">{{$t('t1222_Create_Account')}}</button>
          <span class="back-link"><a href="javascript:void(0)" @click="registerBack()">{{$t('Back')}}</a></span>
        </div>

      </div>

    </div>
  </div><!--container结束-->
</div>
</template>

<script>
  import auth from '../auth/auth'
import format from '@/lib/format'
  export default {
    data() {
      return {
        email:'',
        mobile:'',
        vcode: '',
        icode:'',
        password:'',
        error: '',
        realname:'',
        token:'',time:60,showTime:false,
        newStyle:false,
        send:this.$t('Getcode'),Ema:this.$t('Enter email'),Mob:this.$t('Enter mobile'),
        Veri:this.$t('Entercode'),invi:this.$t('Invitation'),fullname:this.$t('full name'),Enterpas:this.$t('Enter pass'),
        canClick:false,
        /*country:['GB','CN','FR','DD','SE','AU','HKF','HU','IT','NL','Nor','PT','ES','TR'],*/
        country:['GB','CN','FR','DD','SE','AU','HKF','HU','IT','NL',   // 10个一行
          'Nor','PT','ES','TR','AE','Ro','CZ','SK','LT','PL',   // 便于计数
          'DK','FI','TH','ID','MY','IN','CH','SA','AE','QA',
          'QW','RH','AT','SI','EE','LV','BA','BG','CL', 'BE'          // 2020.1.2 增加， RH 到 CL ， 共8个
        ],  // 保持一致

        isA:false, isB:true, isC:false, isD:true, isE:false, isF:false,
        isG:false, isH:false, isI:false, isJ:false, isK:false,
        isO:false, isP:false,isQ:false, isR:false,isS:false, isT:false,
        disA:true, disB:true,disC:true, disD:true,disE:true, disF:true, //设置提示
        //密码提示
        ps1:false, ps2:false, ps3:false, ps4:false, ps5:false, ps6:false,hostname:'',
        tabA:true, tabB:false,isA2:false, isAgree:false, isEU:true, isNext:false,
        // contactURL:'',
        privacyURL:'',
        termsOfUseURL:'',
      }
    },
    vuerify: {
      realname:'realname',
      icode:'icode',
      vcode:'icode',
      mobile:'mobile',
      email: 'email',
    },
    computed: {
      errors () {
        return this.$vuerify.$errors
      },
      getLanguage(){
        return this.$store.state.language;
      }
    },
    watch:{
      //在computed中实时返回state中的数据，然后watch中监听
      getLanguage(val){
        this.send = this.$t('Getcode');
        this.Ema = this.$t('Enter email');
        this.Mob =  this.$t('Enter mobile');
        this.Veri = this.$t('Entercode');
        this.fullname = this.$t('full name');
        this.Enterpas = this.$t('Enter pass');
        if(val==='zh'){
          this.newStyle=true;
        }else{
           this.newStyle=false;
        }
      }
    },
    mounted(){
       auth.initLanguages(this);
      let lang = sessionStorage.getItem('language');
      this.newStyle = (lang==='zh'||lang ==='hk')?true:false;
      let index = localStorage.getItem('index');
      if(index){
         let country = this.country[index];
         let obj = document.getElementById('chooseCountry');
         for(let i=0;i<obj.options.length;i++){
             if(obj.options[i].value===country){
               obj.options[i].selected = true;
               break;
             }
         }
      }

      setTimeout(()=>{
        let host=auth.getOuterHost();
        console.log("sign host:", host);
        // this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }, 50)

    },
    methods: {
      //注册
      register(e) {
        let info = {
          user_type:(this.isB ? 'P':'M') ,
          user_name: (this.isD?this.email:this.mobile) ,
          password: this.password,
          real_name:this.realname.trim(),
          country:'',
          token:this.token,
          seccode:this.vcode,
          ver:2,
        };
        if(this.$vuerify.valid){    // 验证vuerify定义的字段， 并且这个vue实例具有的字段。
          let obj = document.getElementById('chooseCountry');
          info.country = obj.value;
          info.test='yes';

          if (-1==e.target.className.indexOf('create-account')) {
            //
          } else {
            delete info.test;
          }
          //console.info('register:'+e.target.className)
          //console.info('register:'+info.test)
          auth.register(this,info);
          //console.log(info);

          /*
          this.tabA=false;
          this.tabB=true;

          if ('CN'==info.country || 'HKF'==info.country || 'AE'==info.country) {
            this.isEU=false;
          }
          console.log('isEU:'+this.isB)*/

          if ('CN'==info.country) {
            this.isEU=false;
          }


        }else{
          //let err = 'Please fill in all required fields.';
          let err=this.$t('infoWrongTip');
          alert(this.$vuerify.$errors.email||err);
        }
      },
      //发送验证码
      sendSeccode(){
        let para = {
          user_name:(this.isD?this.email:this.mobile) ,
          country:'',
          flag: (this.isD )? 'email': 'mobile' ,
          purpose:'regist',
        };
        let obj = document.getElementById('chooseCountry');
        para.country = obj.value;
        let wright = (this.isD)?this.disA:this.disB;
        if((para.user_name!=="")&&wright){
          this.$http.get('api/v2.0/user/'+para.user_name).then(function(res){
            let exist =res.body.exist;
            if(exist){
              this.$message.error('The username entered already exists.');
            }else{
              let tip = '';
              if(this.newStyle){
                tip = this.$t('VcodeTip1')+' '+para.user_name;
              }else{
                tip = this.$t('VcodeTip3')+' '+para.user_name;
              }
              this.$message({
                type: 'success',
                message:tip
              });
              auth.sendSeccode(this,para);
              auth.setTime(this);
            }
          });
        }else {
          let tip = this.$t('Input error');
          this.$message.error(tip);
          this.isO =true;
        }
      },
      //密码验证
      checkPassword(){
        let password = this.password.trim();
        if(password.length>5 && password.length<21){ this.ps2 =true; }else{ this.ps2 =false; }
        if(password.length>0) {
          if(password.indexOf(' ')===-1){ this.ps6 =true; }else{ this.ps6 =false; }
          if(password!==this.realname.trim()){ this.ps3 =true; }else{ this.ps3 =false; }
          let p1=/[a-z]/.test(password),p2=/[A-Z]/.test(password),p3=/[0-9]/.test(password),p4=/[!@#$%^&*()_+={},.;'\\":~`\[\]<>|/?]/.test(password),count=0;
          if(p1){count++;}
          if(p2){count++;}
          if(p3){count++;}
          if(p4){count++;}
          if(count>2){
            this.ps1 =true;
          }else{ this.ps1 =false; }

          for(let i =0;i<password.length-2;i++){
            if(password[i+1]-password[i]===1&&password[i+2]-password[i+1]===1){
              this.flag = 1;break;
            }else{
              this.flag = 0;
            }
            if(password[i]-password[i+1]===1&&password[i+1]-password[i+2]===1){
              this.flag = 1;break;
            }else{
              this.flag = 0;
            }
          }
          if(this.flag===0){ this.ps4 =true; }else{ this.ps4 =false; }

          for(let i =0;i<password.length-2;i++){
            if(password[i+1].charCodeAt()-password[i].charCodeAt()===1 && password[i+2].charCodeAt()-password[i+1].charCodeAt()===1){
              this.flag1 = 1;break;
            }else{
              this.flag1 = 0;
            }
            if(password[i].charCodeAt()-password[i+1].charCodeAt()===1 && password[i+1].charCodeAt()-password[i+2].charCodeAt()===1){
              this.flag1 = 1;break;
            }else{
              this.flag1 = 0;
            }
          }
          if(this.flag1===0){ this.ps5 =true; }else{ this.ps5 =false; }
        }
        if(this.ps1===true && this.ps2===true && this.ps3===true && this.ps4===true && this.ps5===true && this.ps6===true){
          this.isT = false;
          this.disF = true;
        }else{
          this.isT = true;
          this.disF = false;
        }
      },

      check1:function(){
        this.isA = !this.isA;
        this.isAgree= this.isA && this.isA2;
        //console.log('isAgree:'+this.isA+','+this.isA2)
      },
      check1_2:function(){
        this.isA2 = !this.isA2;
        this.isAgree= this.isA && this.isA2;
        //console.log('isAgree:'+this.isA+','+this.isA2)
      },
      check2:function(){
        this.isB = !this.isB;
        this.isC = !this.isC;
      },
      registerBack:function(){
        this.tabA=true;
        this.tabB=false;
      },
      check3:function(){
        this.isD = !this.isD;
        this.isE = !this.isE;
      },

      check54(flag){
        this.isF = !this.isF;
        //修改占位符
        if(this.Ema === ''){
          this.Ema = this.$t('Enter email');
        }else{
          this.Ema = '';
        }
        //光标离开，验证输入
        if(flag===1){
          if (this.$vuerify.$errors.email || this.email === '') {
            this.isO = true;
            this.disA = false;
          }else{
            this.isO = false;
            this.disA = true;
        }
        }
      },
      check55(flag){
        this.isG = !this.isG;
        if(this.Mob === ''){
          this.Mob =  this.$t('Enter mobile');
        }else{
          this.Mob = '';
        }
        if(flag===1){
          if (this.$vuerify.$errors.mobile || this.mobile === '') {
            this.isP = true;
            this.disB = false;
          }else{
            this.isP = false;
            this.disB = true;
          }
        }
      },
      check56(flag){
        this.isH = !this.isH;
        if(this.Veri === ''){
          this.Veri = this.$t('Entercode');
        }else{
          this.Veri = '';
        }
        if(flag===1){
          if (this.$vuerify.$errors.vcode || this.vcode === '') {
            this.isQ = true;
            this.disC = false;
          }else{
            this.isQ = false;
            this.disC = true;
          }
        }
      },
      check58(flag){
        this.isJ = !this.isJ;
        if(this.fullname === ''){
          this.fullname = this.$t('full name');
        }else{
          this.fullname = '';
        }
        if(flag===1) {
          //  console.log(this.realname);
          if (this.$vuerify.$errors.realname || this.realname === '') {
            this.isS = true;
            this.disE = false;
          } else {
            this.isS = false;
            this.disE = true;
          }
        }
      },
      check59(flag){
        this.isK = !this.isK;
        if(this.Enterpas === ''){
          this.Enterpas = this.$t('Enter pass');
        }else{
          this.Enterpas = '';
        }
        if(flag===1) {
          this.checkPassword();
        }
      },

      //点击方向键切换输入框
      down(index){
          let obj = document.getElementById('inputGroup');
          let inputs = obj.getElementsByTagName('input');
          inputs[index+1].focus();
      },
      up(index){
        let obj = document.getElementById('inputGroup');
        let inputs = obj.getElementsByTagName('input');
        if(index===2){
          if(this.isD){ inputs[0].focus();}
          if(this.isE){ inputs[1].focus();}
        }else{
          inputs[index-1].focus();
        }
      },

      select(e){
        let country = e.target.value;
        let route ='sign';
        auth.changeServer(this,country,route);
      }
    }
  }
</script>

<style scoped>
  .wrapper{
    width:400px;
    height:662px;
    margin: 0 auto;
  }

  .container{
    height:622px;
    padding-top: 15px;
    background: rgba(235,238,241,0.6);
    border-radius:14px;
  }
  .newStyle2{
    height:652px;
  }
  .cont-head{
    height:35px;
    width:180px;
    margin:0 auto 15px;
    font-family:SFUIText-Medium;
    font-size:26px;
    color:#323232;
    letter-spacing:-0.63px;
    line-height:35px;
    text-align:center;
  }
  .newStyle{
    margin-bottom: 20px;
  }
  .newStyle span{
    display: block;
    margin-top:15px;
  }
  .user-type{
    opacity:0.8;
    background:#fff;
    box-shadow:0 2px 7px 0 rgba(210,210,210,0.50);
    border-radius:100px;
    width:324px;
    height:45px;
    margin:0 auto 15px;
    color:#323232;
  }
  .user-left{
    *opacity:0.8;
    box-shadow:0 2px 7px 0 rgba(210,210,210,0.50);
    width:162px;
    height:45px;
    float:left;
  }
  .user-type input{
    width: 15px;
    height:15px;
    margin:15px 10px 15px 22px;
  }
  .user-type label{
    font-family:SFUIText-Regular;
    font-size:20px;
    letter-spacing:-0.49px;
    text-align:left;
  }
  .user-right{
    width:162px;
    height:45px;
    float:right;
  }
  .hide1{
    opacity: 0;
  }
  .Select2{
    background-image: url("../assets/Select_2.png");
    background-repeat: no-repeat;
    background-position: 22px center;
  }
  .choose-left{
    background-color:#009fdf;
    color: #fff;
    border-bottom-left-radius:100px ;
    border-top-left-radius:100px ;
  }
  .choose-right{
    background-color:#009fdf;
    color: #fff;
    border-bottom-right-radius:100px ;
    border-top-right-radius:100px ;
  }

  hr{
    background:rgba(255,255,255,0.50);
    width:400px;
    height:2px;
    margin:20px 0;
    border:none;
  }
  .broad {
    width: 600px;
  }
  .next_btn {
    width: 326px;
    margin: 0 auto;
  }

  .icon-bor,.icon-spe1,.icon-spe2{
    opacity:0.79;
    background:#ffffff;
    box-shadow:0px 2px 7px 0px rgba(210,210,210,0.50);
    font-family: SFUIText-Regular;
    border-radius:100px;
    width:320px;
    height:46px;
    margin:0 auto 20px;
  }
  .icon-bor #chooseCountry{
    width:280px;
    height:38px;
    font-family:SFUIText-Regular;
    font-size:19px;
    color:#222;
    letter-spacing:-0.49px;
    text-align:left;
    margin-left: 16px;
    margin-top: 4px;
    border:none;
    outline: none;
    padding-left: 5px;
    padding-right: 5px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url("../assets/arrow_down.png") right center no-repeat;
  }
  .icon-bor input,.icon-spe2 input{
    height:26px;
    width:190px;
    line-height: 30px;
    font-size:20px;
    font-family: SFUIText-Regular;
    letter-spacing:-0.69px;
    text-align:left;
    border: none;
    margin-top: 8px;
    margin-left:22px;
    color: #282828;
  }
  .icon-bor input:focus,.icon-spe1 input:focus,.icon-spe2 input:focus{
    color: #2aace0;
    border: none;
    outline:none;
  }
  .mobile-choose{
    opacity:0.9;
    width:85px;
    height:45px;
    float: left;
    margin-left:-5px;
    border-right:1px solid #ccc;
  }
  .mobile-choose select{
    font-family:SFUIText-Regular;
    font-size:20px;
    color:#323232;
    letter-spacing:-0.66px;
    text-align:left;
    height:26px;
    margin: 11px 0 11px 20px;
    border:none;
    outline: none;
  }
  .icon-spe1 input{
    width:185px;
    font-family:SFUIText-Regular;
    font-size:20px;
    color:#d2d2d2;
    letter-spacing:-0.49px;
    text-align:left;
    display: block;
    float: left;
    margin:10px 0 11px 20px;
    border:none;
  }
  .icon-spe4 input{
    width:184px;
  }
  .time{
    opacity:0.8;
    background:#009fdf;
    box-shadow:0 2px 7px 0 rgba(210,210,210,0.50);
    width:100px;
    height:46px;
    float:right;
    margin-left:10px;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;
    cursor: pointer;
  }
  .time button{
    background: transparent;
    border:none;
    outline: none;
  }
  .time label{
    display: block;
    font-family: SFUIText-Regular;
    font-size:20px;
    width:84px;
    height:24px;
    margin-left:6px;
    color:#f6f9fa;
    margin-top:10px;
    letter-spacing:-0.49px;
    text-align:center;
    cursor: pointer;
  }
  .time span.showTime{
    width: 35px;
    height:24px;
    line-height: 24px;
    display: inline-block;
    font-family: SFUIText-Regular;
    font-size:20px;
    letter-spacing:-0.49px;
    color:#f6f9fa;
    margin:0;
  }
  .zh1 label{
    font-family: SFUIText-Regular;
    font-size:17px;
    margin-top:12px;
  }
  /*为了解决输入时元素加边框带来的位置移动的问题，改变属性抵消变化*/
  .in{
    /*抵消元素的大小变化*/
    border:1px solid #009fdf;
    height:44px;
    width:318px;
  }
  .in1{
    /*抵消内部元素的位置移动*/
    margin-left:-6px;
    margin-top:-1px;
  }
  .in2{
    margin-right:-1px;
    margin-top:-1px;
  }

  /*表单验证提示框*/
  .tooltip span,.tooltip p{
    font-family:SFUIText-Regular;
    font-size:15px;
    letter-spacing:-0.37px;
    text-align: left;
    color:#3b3b3b;
  }
  .operate{
    width:290px;
    height:32px;
    margin:20px auto 22px;
  }
  .operate input{
    width:16px;
    height:32px;
    filter:alpha(opacity=0);
    opacity: 0;
    float:left;
    cursor: pointer;
  }
  .Select{
    background: url("../assets/Select.png") left center no-repeat;
  }
  .noSelect{
    background: url("../assets/No Select.png") left center no-repeat;
  }
  .operate label{
    font-family: SFUIText-Regular;
    font-size:14px;
    color:#5a5a5a;
    letter-spacing:-0.34px;
    text-align:left;
    display: block;
    width:262px;
    margin-left:25px;
    padding-top:7px;
  }
  .operate a{
    text-decoration: none;
    color:#009fdf;
  }
  .operate a:hover{
    opacity:0.6;
  }

  .tooltip p{
    background: url('../assets/no.png') left center no-repeat;
    padding-left: 22px;
    margin-bottom: 2px;
  }
  .tooltip .longP{
    background: url('../assets/no.png') left 1px no-repeat;
  }
  .tooltip .correct{
    background: url('../assets/yes.png') left center no-repeat;
  }
  .tooltip .correct1{
    background: url('../assets/yes.png') left 1px no-repeat;
  }
  /*使提示框居中，加大输入框的长度，offset不起作用的解决措施*/
  .icon-bor .longps{
    width:260px;
  }

  .register {
    height: 45px;
    line-height: 45px;
    width: 324px;
    margin: 0 auto;
    font-family: SFUIText-Regular;
    box-shadow:0px 2px 7px 0px rgba(210,210,210,0.50);
    background:#009fdf;
    border-radius:100px;
    font-size:20px;
    color:#f6f9fb;
    letter-spacing:-0.49px;
    text-align:center;
    opacity:0.3;
    cursor: pointer;
    outline: none;
    border:none;
  }

  .create-account {
    height: 45px;
    line-height: 45px;
    width: 200px;
    *margin: 0 20px;
    margin-top:30px;
    font-family: SFUIText-Regular;
    box-shadow:0px 2px 7px 0px rgba(210,210,210,0.50);
    background:#009fdf;
    border-radius:100px;
    font-size:20px;
    color:#f6f9fb;
    letter-spacing:-0.49px;
    text-align:center;
    opacity:0.3;
    cursor: pointer;
    outline: none;
    border:none;
  }

  .back-link {
    margin-left:40px;
  }

  .newStyle1{
    margin-top: 10px;
  }
  .click:hover{
    opacity:0.6;
  }
  .click{
    opacity: 0.8;
  }
  .vuerify-invalid{
    border: 1px solid #ff5252;
    height:44px;
    width:318px;
  }
  .icon-bor span,.icon-spe2 span{
    height:12px;
    line-height:12px;
    display: block;
    color: #ff5252;
    font-family: SFUIText-Regular;
    font-size: 12px;
    margin-left: 30px;
    margin-top:13px;
  }
  .icon-spe1 span{
    height:12px;
    width:140px;
    line-height:12px;
    display: block;
    color: #ff5252;
    font-family: SFUIText-Regular;
    font-size: 12px;
    margin-left:30px;
    margin-top:47px;
  }

  .policy-wrap {
    padding:20px;
  }

  .policy-wrap .text_wrap {
    min-height: 500px;

  }

  .policy-wrap p{
    font-size:18px;
  }

  .policy-wrap .check input {
    opacity: 0;
  }
  .policy-wrap .check span {
    margin-left:10px;
  }

  @media screen and (max-width: 1500px){
    .wrapper{
      height:636px;
    }
    .container{
      height:620px;
      padding-top: 20px;
    }
    .cont-head{
      margin:0 auto 20px;
    }
    .newStyle2{
      height:652px;
    }
  }
</style>



// WEBPACK FOOTER //
// Sign.vue?6b265ce3